import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BodyTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: BodyTypeRow[];
  loading?: boolean;
};

const BodyTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "bodyTypeId",
        label: t("BODY_TYPE.TABLE.NUMBER"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: BodyTypeRow) => (
          <span className={styles.numberCell}>{row.bodyTypeId}</span>
        ),
      },
      {
        id: "bodyTypeName",
        label: t("BODY_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        format: (row: BodyTypeRow) => (
          <span className={styles.textCell}>{row.bodyTypeName}</span>
        ),
      },
    ],
    [styles, t],
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        scrollClass="custom-scroll-bar"
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("BODY_TYPE.EMPTY")}
      />
    </div>
  );
};

export default BodyTypeTable;
